<p-toast></p-toast>
<p-drawer
  styleClass="floatbar requirement-submission-drawer"
  [(visible)]="visible"
  (onHide)="_onHide()"
  [position]="position"
  [style]="{ width: '700px' }"
  [dismissible]="false"
  [showCloseIcon]="false"
  [closeOnEscape]="false"
  >
  @if (visible) {
    <div class="sidebar-content">
      <!-- Form for view mode -->
      @if (viewMode) {
        <form [formGroup]="form" (ngSubmit)="save()">
          <header class="floatbar-header">
            <div class="row">
              <div class="header-title">
                <h2 style="margin: 0; color: #2c3e50; font-size: 18px; font-weight: 700">{{ 'REQUIREMENT_SUBMISSIONS.VIEW_REQUIREMENT_DETAILS' | translate }}</h2>
              </div>
              <div class="row grid-xsm">
                <div class="cell">
                  <button type="button" class="btn btn-link" (click)="cancel()">{{ 'COMMON.BUTTONS.CANCEL' | translate }}</button>
                </div>
                @if (currentRequirement?.reviewed_expiration_date && currentRequirement?.isNewestLog) {
                  <div class="cell">
                    <button type="submit" [disabled]="reviewedExpirationDateControl.invalid" class="btn btn-primary">
                      <span>{{ 'COMMON.BUTTONS.SAVE' | translate }}</span>
                    </button>
                  </div>
                }
              </div>
            </div>
          </header>
          <!-- View Mode Layout -->
          <div class="floatbar-section" style="padding: 20px">
            @if (currentRequirement) {
              <div class="requirement-detail">
                <!-- Header Section -->
                <div class="header-section mb-4">
                  <h3 style="margin-bottom: 16px; color: #2c3e50; border-bottom: 2px solid #3498db; padding-bottom: 8px">{{ currentRequirement.title }}</h3>
                  <!-- Basic Information Grid -->
                  <div class="info-grid" style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 20px">
                    <div class="info-card" style="background: #f8f9fa; padding: 12px; border-radius: 6px; border-left: 3px solid #3498db">
                      <h5 style="margin: 0 0 8px 0; color: #495057; font-size: 14px; font-weight: 600">
                        {{
                        model.pass_category === 17 || model.pass_category === 18 ? ('HME.LABELS.EQUIPMENT_ID' | translate) : ('REQUIREMENT_SUBMISSIONS.FIELDS.FULL_NAME' | translate)
                        }}
                      </h5>
                      <p style="margin: 0; color: #2c3e50; font-weight: 500">
                        {{ model.full_name || (model.pass_first_name || model.pass_last_name ? ((model.pass_first_name || '') + ' ' + (model.pass_last_name || '')).trim() : '-') }}
                      </p>
                    </div>
                    <div class="info-card" style="background: #f8f9fa; padding: 12px; border-radius: 6px; border-left: 3px solid #e74c3c">
                      <h5 style="margin: 0 0 8px 0; color: #495057; font-size: 14px; font-weight: 600">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.TYPE' | translate }}</h5>
                      <p style="margin: 0; color: #2c3e50; font-weight: 500">{{ 'GENERAL.' + currentRequirement.type | translate }}</p>
                    </div>
                  </div>
                  <!-- Creator Information -->
                  @if (model.creator_full_name || model.creator_mobile) {
                    <div
                      class="creator-info mb-3"
                      style="background: #e7f3ff; padding: 12px; border-radius: 6px; border-left: 3px solid #0066cc"
                      >
                      <h5 style="margin: 0 0 8px 0; color: #003d7a; font-size: 14px; font-weight: 600">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.CREATOR_INFO' | translate }}</h5>
                      <div style="display: flex; gap: 16px; flex-wrap: wrap">
                        @if (model.creator_full_name) {
                          <div>
                            <span style="color: #495057; font-size: 12px">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.CREATOR_NAME' | translate }}:</span>
                            <span style="color: #2c3e50; font-weight: 500; margin-inline-start: 4px">{{ model.creator_full_name }}</span>
                          </div>
                        }
                        @if (model.creator_mobile) {
                          <div>
                            <span style="color: #495057; font-size: 12px">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.CREATOR_PHONE' | translate }}:</span>
                            <span style="color: #2c3e50; font-weight: 500; margin-inline-start: 4px"
                              >{{ model.creator_country_code ? model.creator_country_code + '-' : '' }}{{ model.creator_mobile }}</span
                              >
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                  <!-- Content Section -->
                  <div class="content-section mb-4">
                    <!-- Content Link -->
                    @if (currentRequirement.type === 'FORM') {
                      <div class="mb-3" style="background: #e8f4fd; padding: 12px; border-radius: 6px; border: 1px solid #bee5eb">
                        <h5 style="margin: 0 0 8px 0; color: #0c5460; font-size: 14px; font-weight: 600">{{ 'GENERAL.CONTENT' | translate }}</h5>
                        <a [href]="currentRequirement.content" target="_blank" class="form-link" style="color: #007bff; text-decoration: none; font-weight: 500">
                          {{ 'REQUIREMENT_SUBMISSIONS.FIELDS.VIEW_FORM' | translate }}
                        </a>
                      </div>
                    }
                    <!-- Image Container -->
                    @if (currentRequirement.type === 'IMAGE' && getImageUrls(currentRequirement) && getImageUrls(currentRequirement).length > 0) {
                      <div
                        class="image-section mb-4"
                        style="background: white; padding: 16px; border-radius: 8px; border: 1px solid #dee2e6"
                        >
                        <h5 style="margin: 0 0 12px 0; color: #495057; font-size: 16px; font-weight: 600">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.SUBMITTED_IMAGES' | translate }}</h5>
                        <div class="image-container" style="display: flex; flex-wrap: wrap; gap: 12px">
                          @for (image of getImageUrls(currentRequirement); track image) {
                            <div class="image-wrapper" style="position: relative; display: inline-block; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1)">
                              <!-- PrimeNG Image -->
                              <p-image
                                [src]="image"
                                alt="Requirement Image"
                                width="180"
                                [preview]="true"
                                [showTransitionOptions]="'300ms ease-in-out'"
                                [hideTransitionOptions]="'300ms ease-in-out'"
                                >
                              </p-image>
                              <!-- Fallback image with custom modal -->
                              <div
                                style="position: relative; display: inline-block; cursor: pointer"
                                (click)="openCustomImagePreview(image)"
                                onmouseover="this.querySelector('.click-overlay').style.opacity = '1'"
                                onmouseout="this.querySelector('.click-overlay').style.opacity = '0'"
                                (keydown.enter)="openCustomImagePreview(image)"
                                tabindex="0"
                                role="button"
                                >
                                <img
                                  [src]="image"
                                  alt="Image"
                        style="
                          max-height: 180px;
                          max-width: 100%;
                          border-radius: 6px;
                          transition:
                            transform 0.2s ease,
                            filter 0.2s ease;
                        "
                                  title="Click to preview"
                                  />
                                <!-- Click indicator overlay -->
                                <div
                                  class="click-overlay"
                        style="
                          position: absolute;
                          top: 50%;
                          left: 50%;
                          transform: translate(-50%, -50%);
                          background: rgba(0, 0, 0, 0.7);
                          color: white;
                          border-radius: 50%;
                          width: 40px;
                          height: 40px;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          opacity: 0;
                          transition: opacity 0.3s ease;
                          pointer-events: none;
                        "
                                  >
                                  <i class="pi pi-eye" style="font-size: 16px"></i>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    }
                    <!-- Submitted field values: identification documents and System Fields (YB-2053) -->
                    @if ((currentRequirement.type === 'IMAGE' || currentRequirement.type === 'SYSTEM_FIELDS') && parseCustomFieldData(currentRequirement.submitted_data, currentRequirement.custom_fields_schema).length > 0) {
                      <div
                        class="custom-fields-section mb-4"
                        style="background: white; padding: 16px; border-radius: 8px; border: 1px solid #dee2e6"
                        >
                        <h5 style="margin: 0 0 12px 0; color: #495057; font-size: 16px; font-weight: 600">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.CUSTOM_FIELDS_DATA' | translate }}</h5>
                        <!-- YB-2124: this is a CHANGE to an answer that was already approved, not a
                             fresh submission. What is being approved is the difference. -->
                        @if (isSelfEdit(currentRequirement)) {
                          <div
                            style="display: flex; align-items: center; gap: 8px; margin-bottom: 12px; padding: 8px 10px; background-color: #fff8e1; border-radius: 6px; border-left: 3px solid #f0ad4e; color: #8a6d3b; font-size: 13px"
                            >
                            <i aria-hidden="true" class="pi pi-pencil" style="font-size: 12px"></i>
                            <span>{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.SELF_EDITED_NOTICE' | translate }}</span>
                          </div>
                        }
                        <div class="custom-fields-container" style="display: grid; gap: 8px">
                          @for (field of parseCustomFieldData(currentRequirement.submitted_data, currentRequirement.custom_fields_schema); track field) {
                            <div class="custom-field-item">
                              <div
                                class="custom-field-row"
                                (click)="copyCustomFieldValue(field)"
                                [pTooltip]="'COMMON.TAGS.CLICK_TO_COPY' | translate"
                                tooltipPosition="bottom"
                                style="display: flex; align-items: center; padding: 10px; background-color: #f8f9fa; border-radius: 6px; border-left: 3px solid #28a745; cursor: pointer"
                                (keydown.enter)="copyCustomFieldValue(field)"
                                tabindex="0"
                                role="button"
                                >
                                <div class="custom-field-label" style="font-weight: 600; margin-right: 12px; min-width: 120px; color: #495057; font-size: 14px">{{ field.label }}:</div>
                                <div class="custom-field-value" style="flex: 1; color: #2c3e50; font-weight: 500; display: flex; align-items: center; gap: 8px">
                                  <span>{{ formatCustomFieldValue(field) }}</span>
                                  @if (previousValueOf(currentRequirement, field.id); as previousValue) {
                                    <span
                                      style="color: #8a6d3b; font-weight: 400; font-size: 13px"
                                      [pTooltip]="'REQUIREMENT_SUBMISSIONS.FIELDS.PREVIOUS_VALUE' | translate"
                                      tooltipPosition="bottom"
                                      >
                                      (<s>{{ previousValue }}</s>)
                                    </span>
                                  }
                                  <i aria-hidden="true" class="pi pi-copy" style="font-size: 12px; color: #6c757d"></i>
                                </div>
                                <div class="custom-field-type" style="font-size: 12px; color: #6c757d; margin-left: 10px; font-style: italic">
                                  ({{ 'GENERAL.' + field.type.toUpperCase() | translate }})
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    }
                    <!-- FORM Data -->
                    @if (currentRequirement.type === 'FORM') {
                      <div
                        class="form-data-section mb-4"
                        style="background: #e8f4fd; padding: 12px; border-radius: 6px; border: 1px solid #bee5eb"
                        >
                        <h5 style="margin: 0 0 8px 0; color: #0c5460; font-size: 14px; font-weight: 600">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.SIGNED_AT' | translate }}</h5>
                        <p style="margin: 0; color: #495057; font-weight: 500">{{ getDateFromString(currentRequirement.submitted_data) | date: 'dd/MM/yyyy, HH:mm' }}</p>
                      </div>
                    }
                    <!-- Text Data -->
                    @if (currentRequirement.type === 'TEXT') {
                      <div
                        class="text-data-section mb-4"
                        style="background: #f8f9fa; padding: 12px; border-radius: 6px; border-left: 3px solid #17a2b8"
                        >
                        <h5 style="margin: 0 0 8px 0; color: #495057; font-size: 14px; font-weight: 600">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.SUBMITTED_TEXT' | translate }}</h5>
                        <p style="margin: 0; color: #2c3e50; word-wrap: break-word">{{ currentRequirement.submitted_data }}</p>
                      </div>
                    }
                  </div>
                  <!-- Dates and Information Section -->
                  <div class="dates-info-section">
                    <!-- Additional Information Section -->
                    <div class="additional-info-section mb-4" style="background: #f8f9fa; padding: 16px; border-radius: 8px; border: 1px solid #dee2e6">
                      <h5 style="margin: 0 0 16px 0; color: #495057; font-size: 16px; font-weight: 600">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.ADDITIONAL_INFO' | translate }}</h5>
                      <div class="info-grid" style="display: grid; gap: 12px">
                        <!-- Request ID -->
                        @if (currentRequirement?.submission_id) {
                          <div
                            class="info-row"
                            style="background: white; padding: 10px; border-radius: 6px; display: flex; justify-content: space-between; align-items: center; border-left: 3px solid #3498db"
                            >
                            <span style="font-weight: 600; color: #495057">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.ID' | translate }}:</span>
                            <span style="color: #2c3e50; font-weight: 500">{{ currentRequirement.submission_id }}</span>
                          </div>
                        }
                        <!-- Creation Date -->
                        @if (model?.created_at) {
                          <div
                            class="info-row"
                            style="background: white; padding: 10px; border-radius: 6px; display: flex; justify-content: space-between; align-items: center; border-left: 3px solid #28a745"
                            >
                            <span style="font-weight: 600; color: #495057">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.CREATED_AT' | translate }}:</span>
                            <span style="color: #2c3e50; font-weight: 500">{{ model.created_at | date: 'dd/MM/yyyy, HH:mm' }}</span>
                          </div>
                        }
                        <!-- Approver Name -->
                        @if (currentRequirement?.user_full_name) {
                          <div
                            class="info-row"
                            style="background: white; padding: 10px; border-radius: 6px; display: flex; justify-content: space-between; align-items: center; border-left: 3px solid #e74c3c"
                            >
                            <span style="font-weight: 600; color: #495057">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.USER_FULL_NAME' | translate }}:</span>
                            <span style="color: #2c3e50; font-weight: 500">{{ currentRequirement.user_full_name }}</span>
                          </div>
                        }
                        <!-- Approval Progress -->
                        @if (currentRequirement?.approvals && currentRequirement.approvals.length > 0) {
                          <div
                            class="info-row"
                            style="background: white; padding: 10px; border-radius: 6px; border-left: 3px solid #9b59b6"
                            >
                            <div style="width: 100%">
                              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px">
                                <span style="font-weight: 600; color: #495057">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.APPROVAL_PROGRESS' | translate }}:</span>
                                <span class="badge bg-primary">{{ getApprovalProgress(currentRequirement) }}</span>
                              </div>
                              <div style="font-size: 12px; color: #6c757d">
                                @for (approval of currentRequirement.approvals; track approval) {
                                  <div style="padding: 4px 0; border-top: 1px solid #e9ecef">
                                    <i class="pi pi-check-circle" style="color: #28a745; margin-right: 6px"></i>
                                    <span style="font-weight: 500">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.APPROVED_BY' | translate }} {{ approval.user_id }}</span>
                                    <span style="margin-left: 8px; color: #999">{{ approval.approved_at | date: 'dd/MM/yyyy, HH:mm' }}</span>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        }
                        <!-- Approval Time -->
                        @if (currentRequirement?.approved_at || currentRequirement?.expiration_date) {
                          <div
                            class="info-row"
                            style="background: white; padding: 10px; border-radius: 6px; display: flex; justify-content: space-between; align-items: center; border-left: 3px solid #f39c12"
                            >
                            <span style="font-weight: 600; color: #495057">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.APPROVED_AT' | translate }}:</span>
                            <span style="color: #2c3e50; font-weight: 500">{{ currentRequirement.approved_at || currentRequirement.expiration_date | date: 'dd/MM/yyyy, HH:mm' }}</span>
                          </div>
                        }
                        <!-- Conditional Question Answer -->
                        @if (currentRequirement?.conditional_check && currentRequirement?.conditional_question) {
                          <div
                            class="info-row"
                            style="background: white; padding: 10px; border-radius: 6px; border-left: 3px solid #ffc107"
                            >
                            <div style="width: 100%">
                              <div style="margin-bottom: 6px">
                                <span style="font-weight: 600; color: #495057; font-size: 12px">{{ 'SETTINGS.MENU.REQUIREMENTS.FIELDS.CONDITIONAL_QUESTION' | translate }}:</span>
                                <span style="color: #6c757d; font-size: 11px; margin-left: 4px">{{ currentRequirement.conditional_question }}</span>
                              </div>
                              <!-- User said No (conditional_mark is false) -->
                              @if (currentRequirement.conditional_mark === false) {
                                <div style="background: #f8d7da; padding: 6px 8px; border-radius: 4px; border-left: 3px solid #dc3545">
                                  <i class="pi pi-times-circle" style="color: #721c24; margin-right: 6px"></i>
                                  <span style="color: #721c24; font-size: 12px; font-weight: 500">
                                    {{ 'SETTINGS.MENU.REQUIREMENTS.FIELDS.CONDITIONAL_NO' | translate }}
                                    @if (currentRequirement.conditional_declined_at) {
                                      <span>({{ currentRequirement.conditional_declined_at | date: 'dd/MM/yyyy, HH:mm' }})</span>
                                    }
                                  </span>
                                </div>
                              }
                              <!-- User said Yes (conditional_mark is true) -->
                              @if (currentRequirement.conditional_mark === true) {
                                <div style="background: #d4edda; padding: 6px 8px; border-radius: 4px; border-left: 3px solid #28a745">
                                  <i class="pi pi-check-circle" style="color: #155724; margin-right: 6px"></i>
                                  <span style="color: #155724; font-size: 12px; font-weight: 500">
                                    {{ 'SETTINGS.MENU.REQUIREMENTS.FIELDS.CONDITIONAL_YES' | translate }}
                                  </span>
                                </div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                    <!-- Expiration Date -->
                    @if (currentRequirement.expiration_date) {
                      <div class="mb-3" style="background: #fff3cd; padding: 12px; border-radius: 6px; border-left: 3px solid #ffc107">
                        <h5 style="margin: 0 0 8px 0; color: #856404; font-size: 14px; font-weight: 600">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.EXPIRATION_DATE' | translate }}</h5>
                        <p style="margin: 0; color: #495057; font-weight: 500">{{ currentRequirement.expiration_date | date: 'dd/MM/yyyy, HH:mm' }}</p>
                      </div>
                    }
                    <!-- Reviewd Expiration Date (editable if requires_expiration) -->
                    @if (currentRequirement?.reviewed_expiration_date) {
                      <div class="p-input-filled-light">
                        <div class="mb-3" formGroupName="viewModeForm">
                          <h4>{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.EXPIRATION_DATE' | translate }}</h4>
                          <p-datepicker
                            id="reviewedExpirationDate"
                            formControlName="reviewedExpirationDate"
                            [showIcon]="true"
                            dateFormat="dd/mm/yy"
                            [minDate]="minReviewedExpirationDate"
                            [readonlyInput]="true"
                            [disabled]="currentRequirement && !currentRequirement.isNewestLog"
                            appendTo="body"
                            >
                          </p-datepicker>
                          @if (currentRequirement && !currentRequirement.isNewestLog) {
                            <div class="p-message p-message-info">
                              <div class="p-message-wrapper">
                                <span class="p-message-text">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.HISTORICAL_LOG_WARNING' | translate }}</span>
                              </div>
                            </div>
                          }
                          @if (reviewedExpirationDateControl.invalid && reviewedExpirationDateControl.touched) {
                            <small class="p-error">
                              {{ 'REQUIREMENT_SUBMISSIONS.FIELDS.EXPIRATION_DATE_REQUIRED' | translate }}
                            </small>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </form>
        }
        <!-- Form for edit mode -->
        @if (!viewMode) {
          <form [formGroup]="form" (ngSubmit)="save()">
            <header class="floatbar-header">
              <div class="row">
                <div>
                  <h2 class="no-mg">
                    <span>{{ 'REQUIREMENT_SUBMISSIONS.CHECK_REQUIREMENTS' | translate }}</span>
                  </h2>
                </div>
                <div class="row grid-xsm">
                  <div class="cell">
                    <button type="button" class="btn btn-link" (click)="cancel()">{{ 'COMMON.BUTTONS.CANCEL' | translate }}</button>
                  </div>
                  @if (hasApproveRejectPermission()) {
                    <div class="cell">
                      <button type="submit" [disabled]="!form.valid" class="btn btn-primary">
                        <span>{{ 'COMMON.BUTTONS.SAVE' | translate }}</span>
                      </button>
                    </div>
                  }
                </div>
              </div>
            </header>
            <div class="floatbar-section" style="padding: 16px">
              <!-- Pass Holder Information Section -->
              <div class="header-section mb-2" style="background: #ffffff; padding: 10px; border-radius: 6px; border: 1px solid #dee2e6; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05)">
                <!-- Basic Information Grid - 3 columns for better space usage -->
                <div class="info-grid" style="display: grid; grid-template-columns: 2fr 1fr 1fr; gap: 8px; margin-bottom: 8px">
                  <div class="info-card" style="background: #f8f9fa; padding: 6px 8px; border-radius: 4px; border-left: 3px solid #3498db">
                    <div style="font-size: 10px; color: #6c757d; margin-bottom: 2px">
                      {{ model.pass_category === 17 || model.pass_category === 18 ? ('HME.LABELS.EQUIPMENT_ID' | translate) : ('REQUIREMENT_SUBMISSIONS.FIELDS.FULL_NAME' | translate) }}
                    </div>
                    <div style="font-size: 12px; color: #2c3e50; font-weight: 500">{{ model.full_name || model.pass_first_name + ' ' + model.pass_last_name }}</div>
                  </div>
                  <div class="info-card" style="background: #f8f9fa; padding: 6px 8px; border-radius: 4px; border-left: 3px solid #28a745">
                    <div style="font-size: 10px; color: #6c757d; margin-bottom: 2px">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.ID' | translate }}</div>
                    <div style="font-size: 12px; color: #2c3e50; font-weight: 500">{{ model.id }}</div>
                  </div>
                  @if (model.created_at) {
                    <div class="info-card" style="background: #f8f9fa; padding: 6px 8px; border-radius: 4px; border-left: 3px solid #f39c12">
                      <div style="font-size: 10px; color: #6c757d; margin-bottom: 2px">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.CREATED_AT' | translate }}</div>
                      <div style="font-size: 11px; color: #2c3e50; font-weight: 500">{{ model.created_at | date: 'dd/MM/yy HH:mm' }}</div>
                    </div>
                  }
                </div>
                <!-- Creator Information - More compact inline style -->
                @if (model.creator_full_name || model.creator_mobile) {
                  <div
                    class="creator-info"
            style="
              background: #e7f3ff;
              padding: 6px 8px;
              border-radius: 4px;
              border-left: 3px solid #0066cc;
              display: flex;
              gap: 16px;
              align-items: center;
              flex-wrap: wrap;
              font-size: 11px;
            "
                    >
                    @if (model.creator_full_name) {
                      <div style="display: flex; align-items: center; gap: 4px">
                        <span style="color: #6c757d">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.CREATOR_NAME' | translate }}:</span>
                        <span style="color: #2c3e50; font-weight: 500">{{ model.creator_full_name }}</span>
                      </div>
                    }
                    @if (model.creator_mobile) {
                      <div style="display: flex; align-items: center; gap: 4px">
                        <span style="color: #6c757d">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.CREATOR_PHONE' | translate }}:</span>
                        <span style="color: #2c3e50; font-weight: 500">{{ model.creator_country_code ? model.creator_country_code + '-' : '' }}{{ model.creator_mobile }}</span>
                      </div>
                    }
                  </div>
                }
                <!-- Entry Purpose for Vehicles/HME -->
                @if (entryPurpose && (model.pass_category === 17 || model.pass_category === 18)) {
                  <div
                    class="entry-purpose-info"
                    style="background: #fff3cd; padding: 6px 8px; border-radius: 4px; border-left: 3px solid #ffc107; margin-top: 8px; font-size: 11px"
                    >
                    <div style="display: flex; align-items: center; gap: 4px">
                      <span style="color: #6c757d">{{ 'VEHICLES.LABELS.ENTRY_PURPOSE' | translate }}:</span>
                      <span style="color: #2c3e50; font-weight: 500">{{ entryPurpose }}</span>
                    </div>
                  </div>
                }
              </div>
              <div class="requirement-submissions-list">
                @for (submission of submittedRequirements; track submission; let i = $index) {
                  <div [formGroup]="getSubmissionFormGroup(i)" class="requirement-submission">
                    @if (['IN_REVIEW', 'REJECTED'].includes(submission.status)) {
                      <div>
                        <!-- Requirement Card Container -->
                        <div
                          class="requirement-card"
                          style="background: #ffffff; padding: 10px; margin-bottom: 12px; border-radius: 6px; border: 1px solid #dee2e6; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05)"
                          >
                          <!-- Requirement Header -->
                          <div
                            class="requirement-header mb-2"
                            style="border-bottom: 2px solid #3498db; padding-bottom: 6px; display: flex; justify-content: space-between; align-items: center"
                            >
                            <h3 style="margin: 0; color: #2c3e50; font-size: 14px; font-weight: 600">{{ submission.title }}</h3>
                            <div class="info-card" style="background: #f8f9fa; padding: 3px 8px; border-radius: 4px; border-left: 3px solid #e74c3c">
                              <span style="color: #2c3e50; font-size: 10px; font-weight: 500">{{ 'GENERAL.' + submission.type | translate }}</span>
                            </div>
                          </div>
                          <!-- Conditional Question Section -->
                          @if (submission.conditional_check && submission.conditional_question) {
                            <div
                              class="conditional-section mb-2"
                              style="background: #fff3cd; padding: 8px; border-radius: 4px; border-left: 3px solid #ffc107"
                              >
                              <div style="font-size: 11px; color: #856404; margin-bottom: 4px; font-weight: 600">
                                {{ 'SETTINGS.MENU.REQUIREMENTS.FIELDS.CONDITIONAL_QUESTION' | translate }}
                              </div>
                              <div style="font-size: 12px; color: #495057; margin-bottom: 8px">
                                {{ submission.conditional_question }}
                              </div>
                              <!-- Show opted out message if conditional_declined_at exists -->
                              @if (submission.conditional_declined_at) {
                                <div style="background: #f8d7da; padding: 6px 8px; border-radius: 4px; border-left: 3px solid #dc3545">
                                  <i class="pi pi-times-circle" style="color: #721c24; margin-right: 6px"></i>
                                  <span style="color: #721c24; font-size: 12px; font-weight: 500">
                                    {{ 'SETTINGS.MENU.REQUIREMENTS.FIELDS.USER_OPTED_OUT' | translate }}
                                    ({{ submission.conditional_declined_at | date: 'dd/MM/yyyy, HH:mm' }})
                                  </span>
                                </div>
                              }
                              <!-- Show "user said yes" message if they submitted data (not declined) -->
                              @if (!submission.conditional_declined_at && (submission.submitted_data || (submission.type === 'IMAGE' && getImageUrls(submission)?.length > 0))) {
                                <div
                                  style="background: #d4edda; padding: 6px 8px; border-radius: 4px; border-left: 3px solid #28a745"
                                  >
                                  <i class="pi pi-check-circle" style="color: #155724; margin-right: 6px"></i>
                                  <span style="color: #155724; font-size: 12px; font-weight: 500">
                                    {{ 'SETTINGS.MENU.REQUIREMENTS.FIELDS.USER_ANSWERED_YES' | translate }}
                                  </span>
                                </div>
                              }
                            </div>
                          }
                          <!-- Image Container -->
                          @if (submission.type === 'IMAGE' && getImageUrls(submission) && getImageUrls(submission).length > 0) {
                            <div
                              class="image-section mb-2"
                              style="background: white; padding: 6px; border-radius: 4px; border: 1px solid #e9ecef"
                              >
                              <div style="font-size: 10px; color: #6c757d; margin-bottom: 6px; font-weight: 600">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.SUBMITTED_IMAGES' | translate }}</div>
                              <div class="image-container" style="display: flex; flex-wrap: wrap; gap: 6px">
                                @for (image of getImageUrls(submission); track image) {
                                  <div class="image-wrapper" style="position: relative; display: inline-block; border-radius: 4px; overflow: hidden; box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1)">
                                    <!-- Try PrimeNG Image first -->
                                    <p-image
                                      [src]="image"
                                      alt="Requirement Image"
                                      width="100"
                                      [preview]="true"
                                      [showTransitionOptions]="'300ms ease-in-out'"
                                      [hideTransitionOptions]="'300ms ease-in-out'"
                                      >
                                    </p-image>
                                    <!-- Fallback regular image with custom modal and click indicator -->
                                    <div
                                      style="position: relative; display: inline-block; cursor: pointer"
                                      (click)="openCustomImagePreview(image)"
                                      onmouseover="this.querySelector('.click-overlay').style.opacity = '1'"
                                      onmouseout="this.querySelector('.click-overlay').style.opacity = '0'"
                                      (keydown.enter)="openCustomImagePreview(image)"
                                      tabindex="0"
                                      role="button"
                                      >
                                      <img
                                        [src]="image"
                                        alt="Image"
                            style="
                              max-height: 100px;
                              max-width: 100%;
                              border-radius: 4px;
                              transition:
                                transform 0.2s ease,
                                filter 0.2s ease;
                            "
                                        title="Click to preview"
                                        />
                                      <!-- Click indicator overlay -->
                                      <div
                                        class="click-overlay"
                            style="
                              position: absolute;
                              top: 50%;
                              left: 50%;
                              transform: translate(-50%, -50%);
                              background: rgba(0, 0, 0, 0.7);
                              color: white;
                              border-radius: 50%;
                              width: 35px;
                              height: 35px;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                              opacity: 0;
                              transition: opacity 0.3s ease;
                              pointer-events: none;
                            "
                                        >
                                        <i class="pi pi-eye" style="font-size: 14px"></i>
                                      </div>
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                          }
                          <!-- Submitted field values: identification documents and System Fields (YB-2053) -->
                          @if ((submission.type === 'IMAGE' || submission.type === 'SYSTEM_FIELDS') && parseCustomFieldData(submission.submitted_data, submission.custom_fields_schema).length > 0) {
                            <div
                              class="custom-fields-section mb-2"
                              style="background: white; padding: 8px; border-radius: 4px; border: 1px solid #e9ecef"
                              >
                              <div style="font-size: 11px; color: #6c757d; margin-bottom: 8px; font-weight: 600">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.CUSTOM_FIELDS_DATA' | translate }}</div>
                              <div class="custom-fields-container" style="display: grid; gap: 6px">
                                @for (field of parseCustomFieldData(submission.submitted_data, submission.custom_fields_schema); track field) {
                                  <div class="custom-field-item">
                                    <div
                                      class="custom-field-row"
                                      (click)="copyCustomFieldValue(field)"
                                      [pTooltip]="'COMMON.TAGS.CLICK_TO_COPY' | translate"
                                      tooltipPosition="bottom"
                                      style="display: flex; align-items: center; padding: 6px 8px; background-color: #f8f9fa; border-radius: 4px; border-left: 3px solid #28a745; cursor: pointer"
                                      (keydown.enter)="copyCustomFieldValue(field)"
                                      tabindex="0"
                                      role="button"
                                      >
                                      <div class="custom-field-label" style="font-weight: 600; margin-right: 8px; min-width: 100px; color: #495057; font-size: 12px">{{ field.label }}:</div>
                                      <div class="custom-field-value" style="flex: 1; color: #2c3e50; font-weight: 500; display: flex; align-items: center; gap: 6px; font-size: 12px">
                                        <span>{{ formatCustomFieldValue(field) }}</span>
                                        <i aria-hidden="true" class="pi pi-copy" style="font-size: 11px; color: #6c757d"></i>
                                      </div>
                                      <div class="custom-field-type" style="font-size: 10px; color: #6c757d; margin-left: 8px; font-style: italic">
                                        ({{ 'GENERAL.' + field.type.toUpperCase() | translate }})
                                      </div>
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                          }
                          <!-- FORM Data with Date -->
                          @if (submission.type === 'FORM') {
                            <div class="form-data-section mb-2" style="background: #e8f4fd; padding: 8px; border-radius: 4px; border: 1px solid #bee5eb">
                              <div style="font-size: 11px; color: #0c5460; margin-bottom: 4px; font-weight: 600">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.SIGNED_AT' | translate }}</div>
                              <div style="font-size: 12px; color: #495057; font-weight: 500">{{ getDateFromString(submission.submitted_data) | date: 'dd/MM/yyyy, HH:mm' }}</div>
                            </div>
                          }
                          <!-- Text Data -->
                          @if (submission.type === 'TEXT') {
                            <div
                              class="text-data-section mb-2"
                              style="background: #f8f9fa; padding: 8px; border-radius: 4px; border-left: 3px solid #17a2b8"
                              >
                              <div style="font-size: 11px; color: #6c757d; margin-bottom: 4px; font-weight: 600">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.SUBMITTED_TEXT' | translate }}</div>
                              <div style="font-size: 12px; color: #2c3e50; word-wrap: break-word">{{ submission.submitted_data }}</div>
                            </div>
                          }
                          <!-- Approval Section -->
                          <div class="approval-section" style="background: #f8f9fa; padding: 8px; border-radius: 4px; margin-top: 12px; border-left: 3px solid #6c757d">
                            <!-- Warning if user has already approved -->
                            @if (hasUserApproved(submission)) {
                              <div class="p-message p-message-info mb-2" style="display: flex; align-items: center; padding: 8px; border-radius: 4px">
                                <i class="pi pi-info-circle" style="margin: 0 8px; font-size: 16px"></i>
                                <span style="font-size: 13px">{{ 'REQUIREMENT_SUBMISSIONS.MESSAGES.ALREADY_APPROVED' | translate }}</span>
                              </div>
                            }
                            <!-- Radio Buttons - Only show if user has approve/reject permission and hasn't approved yet -->
                            @if (hasApproveRejectPermission() && canUserApprove(submission)) {
                              <div class="form-group" style="margin: 0">
                                <div class="inline-radio-group">
                                  <div class="field-radiobutton inline-radio">
                                    <p-radioButton [inputId]="'approve' + i" value="IN_REVIEW" [formControl]="getStatusControl(i)" name="status{{ i }}"> </p-radioButton>
                                    <label [for]="'approve' + i">
                                      {{ 'REQUIREMENT_SUBMISSIONS.FIELDS.APPROVE' | translate }}
                                    </label>
                                  </div>
                                  <div class="field-radiobutton inline-radio">
                                    <p-radioButton [inputId]="'reject' + i" value="REJECTED" [formControl]="getStatusControl(i)" name="status{{ i }}"> </p-radioButton>
                                    <label [for]="'reject' + i">
                                      {{ 'REQUIREMENT_SUBMISSIONS.FIELDS.REJECT' | translate }}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            }
                            <!-- Expiration Date - Shows when requires_expiration is true and user is approving or has approved -->
                            @if (
                              submission.requires_expiration && hasApproveRejectPermission() && (getStatusControl(i).value === 'IN_REVIEW' || getStatusControl(i).value === 'APPROVED')
                              ) {
                              <div
                                class="form-group"
                                >
                                <label [for]="'reviewed_expiration_date' + i" class="form-label fz-14">
                                  {{ 'REQUIREMENT_SUBMISSIONS.FIELDS.EXPIRATION_DATE' | translate }}
                                  @if (!getReviewedExpirationDateControl(i)?.value) {
                                    <span class="color-danger">
                                      *
                                      <span class="sr-only">{{ 'COMMON.FORMS.FIELD_REQUIRED' | translate }}</span>
                                    </span>
                                  }
                                </label>
                                <div class="p-input-filled-light">
                                  <p-datepicker
                                    [id]="'reviewed_expiration_date' + i"
                                    [formControl]="getReviewedExpirationDateControl(i)"
                                    [showIcon]="true"
                                    dateFormat="dd/mm/yy"
                                    [minDate]="minReviewedExpirationDate"
                                    [disabled]="!canApproveRequirement(submission.id)"
                                    appendTo="body"
                                    >
                                  </p-datepicker>
                                </div>
                                @if (getReviewedExpirationDateControl(i).invalid && getReviewedExpirationDateControl(i).touched) {
                                  <small class="p-error">
                                    {{ 'REQUIREMENT_SUBMISSIONS.FIELDS.EXPIRATION_DATE_REQUIRED' | translate }}
                                  </small>
                                }
                              </div>
                            }
                            <!-- Rejection Reason -->
                            @if (getStatusControl(i).value === 'REJECTED') {
                              <div class="form-group">
                                <label [for]="'rejection_reason' + i" class="form-label fz-14">
                                  {{ 'REQUIREMENT_SUBMISSIONS.FIELDS.REJECTION_REASON' | translate }}
                                  @if (isRequired('rejection_reason', i)) {
                                    <span class="color-danger">
                                      *
                                      <span class="sr-only">{{ 'COMMON.FORMS.FIELD_REQUIRED' | translate }}</span>
                                    </span>
                                  }
                                </label>
                                <div class="p-input-filled-light">
                                  <input
                                    [id]="'rejection_reason' + i"
                                    [formControl]="getRejectionReasonControl(i)"
                                    [name]="'rejection_reason' + i"
                                    type="text"
                                    pInputText
                                    [disabled]="!canApproveRequirement(submission.id)"
                                    />
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </form>
        }
      </div>
    }
  </p-drawer>

  <!-- Custom Image Preview Modal -->
  <p-dialog
    [(visible)]="imagePreviewVisible"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    styleClass="image-preview-dialog"
    [style]="{ width: '90vw', height: '90vh' }"
    [header]="'COMMON.BUTTONS.IMAGE_PREVIEW' | translate"
    >
    <div
      class="image-preview-container"
    style="
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      position: relative;
      overflow: auto;
      background:
        linear-gradient(45deg, #f8f9fa 25%, transparent 25%), linear-gradient(-45deg, #f8f9fa 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #f8f9fa 75%),
        linear-gradient(-45deg, transparent 75%, #f8f9fa 75%);
      background-size: 20px 20px;
      background-position:
        0 0,
        0 10px,
        10px -10px,
        -10px 0px;
    "
      >
      <img
        [src]="previewImageUrl"
        alt="Preview"
        [style.transform]="'rotate(' + imageRotation + 'deg) scale(' + imageZoom + ')'"
        style="max-width: 100%; max-height: 100%; object-fit: contain; transition: transform 0.3s ease; cursor: grab; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15); border-radius: 8px"
        (mousedown)="$event.preventDefault()"
        />

      <!-- Image Controls Overlay -->
      <div
      style="
        position: absolute;
        top: 15px;
        right: 15px;
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(10px);
        border-radius: 12px;
        padding: 10px;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
      "
        >
        <!-- Rotation Controls -->
        <div style="display: flex; gap: 6px; margin-bottom: 8px">
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            (click)="rotateCounterClockwise()"
            [title]="'COMMON.BUTTONS.ROTATE_COUNTER_CLOCKWISE' | translate"
            style="width: 40px; height: 36px; display: flex; align-items: center; justify-content: center; border-radius: 8px; transition: all 0.2s ease"
            >
            <i class="pi pi-refresh" style="transform: scaleX(-1); font-size: 14px"></i>
          </button>
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            (click)="rotateClockwise()"
            [title]="'COMMON.BUTTONS.ROTATE_CLOCKWISE' | translate"
            style="width: 40px; height: 36px; display: flex; align-items: center; justify-content: center; border-radius: 8px; transition: all 0.2s ease"
            >
            <i class="pi pi-refresh" style="font-size: 14px"></i>
          </button>
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm"
            (click)="resetImageRotation()"
            [title]="'COMMON.BUTTONS.RESET_ROTATION' | translate"
          style="
            width: 40px;
            height: 36px;
            font-size: 11px;
            font-weight: bold;
            border-radius: 8px;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            justify-content: center;
          "
            >
            0°
          </button>
        </div>

        <!-- Zoom Controls -->
        <div style="display: flex; gap: 6px">
          <button
            type="button"
            class="btn btn-outline-success btn-sm"
            (click)="zoomIn()"
            [title]="'COMMON.BUTTONS.ZOOM_IN' | translate"
            style="width: 40px; height: 36px; display: flex; align-items: center; justify-content: center; border-radius: 8px; transition: all 0.2s ease"
            >
            <i class="pi pi-plus" style="font-size: 14px"></i>
          </button>
          <button
            type="button"
            class="btn btn-outline-warning btn-sm"
            (click)="zoomOut()"
            [title]="'COMMON.BUTTONS.ZOOM_OUT' | translate"
            style="width: 40px; height: 36px; display: flex; align-items: center; justify-content: center; border-radius: 8px; transition: all 0.2s ease"
            >
            <i class="pi pi-minus" style="font-size: 14px"></i>
          </button>
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm"
            (click)="resetZoom()"
            [title]="'COMMON.BUTTONS.RESET_ZOOM' | translate"
          style="
            width: 40px;
            height: 36px;
            font-size: 11px;
            font-weight: bold;
            border-radius: 8px;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            justify-content: center;
          "
            >
            100%
          </button>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <button type="button" class="btn btn-primary" (click)="closeImagePreview()">
        {{ 'COMMON.BUTTONS.CLOSE' | translate }}
      </button>
    </ng-template>
  </p-dialog>
